import { KSIPreRequestWorker } from '@sailor/ksi-tools-preload-request';
import { SLPreloadAPIRegistry } from '@/src/common/SLPreloadApi/Business/Registry';

const APPCPreloadSDK = new KSIPreRequestWorker(SLPreloadAPIRegistry, true);

function preloadUpdateRegister() {
  const Horn = Mach?.requireModule?.('SLCHorn');
  APPCPreloadSDK.workerRegister(Horn?.getAppConfig?.()?.appPreloadApi || {});
}

const WMEventCenter = Mach?.requireModule?.('EventCenter');
WMEventCenter?.addListener?.('sailorHornUpdateEvent', () => {
  preloadUpdateRegister();
});

preloadUpdateRegister();
